<div *ngIf="isHidden; else testTool" class="test-tool__hidden">
  <button (click)="toggleTestTool()">ƒ</button>
</div>

<ng-template #testTool>
  <div cdkDrag class="test-tool">
    <div cdkDragHandle class="test-tool__title">Test-Tool</div>
    <button
      data-e2e="test-tool-fragment__close-button"
      class="test-tool__x"
      (click)="toggleTestTool()"
    >
      x
    </button>

    <ng-container *ngIf="(deployments$ | async)?.length">
      <div class="test-tool__element">
        <label for="deployment-select">Deployment:</label>
        <select
          id="deployment-select"
          class="test-tool__right"
          [(ngModel)]="selectDeployment"
          (ngModelChange)="applyDeployment()"
        >
          <option
            *ngFor="let deployment of deployments$ | async"
            [ngValue]="deployment"
          >
            {{ deployment.folder.substring(0, selectMaxLength) }}
          </option>
        </select>
      </div>

      <div *ngIf="selectDeployment" class="test-tool__element">
        <span
          >Deployed {{ selectDeployment.lastModification | date: "MMM d" }} at
          {{ selectDeployment.lastModification | date: "H:mm" }}</span
        >
        <a
          *ngIf="selectDeployment?.jiraUrl"
          id="jira"
          target="_blank"
          class="test-tool__right"
          [href]="selectDeployment.jiraUrl"
          >{{ selectDeployment.jiraId }}</a
        >
      </div>
      <ng-container *ngIf="(latestDeployments$ | async)?.length">
        <hr />
        <div class="test-tool__element test-tool__latest">
          Latest Deployments
        </div>
        <div
          *ngFor="let deployment of latestDeployments$ | async"
          class="test-tool__element"
        >
          <label>{{ deployment.lastModification | date: "H:mm" }}</label>
          <a [href]="deployment.url" class="test-tool__right">
            {{ deployment.folder.substring(0, selectMaxLength) }}
          </a>
        </div>
      </ng-container>
      <hr />
    </ng-container>

    <div class="test-tool__element">
      <label for="theme-select">Theme:</label>
      <select
        id="theme-select"
        class="test-tool__right"
        [(ngModel)]="selectTheme"
        (ngModelChange)="applyTheme()"
      >
        <option *ngFor="let theme of themes" [ngValue]="theme">
          {{ theme.label.substring(0, selectMaxLength) }}
        </option>
      </select>
    </div>

    <div *ngIf="languages$ | async" class="test-tool__element">
      <label for="language-select">Language: </label>
      <button class="test-tool__right" (click)="toggleLanguageRotation()">
        {{ (isLanguageRotationActive$ | async) ? "x" : "»" }}
      </button>
      <select
        id="language-select"
        class="test-tool__right"
        [(ngModel)]="selectLanguage"
        (ngModelChange)="applyLanguage()"
        [disabled]="(isLanguageRotationActive$ | async) === true"
      >
        <option
          *ngFor="let language of languages$ | async"
          [ngValue]="language.value"
        >
          {{ language.title | translate }}
        </option>
      </select>
    </div>

    <div class="test-tool__element">
      <label for="log-level-select">Log-Level:</label>
      <select
        id="log-level-select"
        class="test-tool__right"
        [(ngModel)]="selectLogLevel"
        (ngModelChange)="applyLogLevel()"
      >
        <option *ngFor="let logLevel of logLevels; let i = index" [ngValue]="i">
          {{ logLevel }}
        </option>
      </select>
    </div>

    <div class="test-tool__element">
      <button (click)="refreshToken()">Refresh Token</button>
    </div>

    <div class="test-tool__element">
      <button (click)="clearSiteDataAndReload()">
        Clear site data & reload
      </button>
    </div>

    <div class="test-tool__footer">
      <a href="https://confluence.nfon.net/x/Kw04L" target="_blank"
        >Documentation</a
      >
    </div>
  </div>
</ng-template>
